import React, { useState } from 'react';

// import classNames from 'classnames';

import ModalDialog from 'components/ModalDialog/ModalDialog';
// import { ReactComponent as CalendarIcon } from 'assets/icons/calendar-new.svg';
// import TextField from 'clean/components/common/TextField/TextField';

import Tabs from 'clean/components/common/Tabs/Tabs';

import styles from './SwitchModal.module.scss';
// import GradeInput from '../GradeInput/GradeInput';
import AssignmentSelect from '../AssignmentSelect/AssignmentSelect';

interface Props {
  onClose: () => void;
}

const EditGradeModal: React.FC<Props> = ({ onClose }) => {
  const [showGradeInput, setShowGradeInput] = useState(false);
  const [selectedTab, setSelectedTab] = useState('existingTask');
  const [selectedAssignmentId, setSelectedAssignmentId] = useState(null);

  return (
    <ModalDialog
      open={true}
      hasContentPadding={false}
      onClose={onClose}
      title={showGradeInput ? 'Edit cell' : 'Aaron Fischer'}
      actions={[
        {
          type: 'filled',
          colour: 'primary',
          fullWidth: true,
          label: 'Continue',
          handler: () => {
            setShowGradeInput(false);
          },
        },
      ]}
    >
      <div className={styles.container}>
        <Tabs
          showBorderBottom={true}
          height="48px"
          fullWidth={true}
          selectedTabId={selectedTab}
          onChange={tab => setSelectedTab(tab.id)}
          tabs={[
            { id: 'newTask', label: 'New assignment' },
            { id: 'existingTask', label: 'Choose existing' },
          ]}
        />
        {selectedTab === 'newTask' && (
          <div className={styles.padding} style={{ padding: '20px', textAlign: 'center' }}>
            Not implemented
          </div>
        )}
        {selectedTab === 'existingTask' && (
          <div className={styles.padding}>
            <div className={'form-text-label'}>Assignment</div>
            <AssignmentSelect value={selectedAssignmentId} onChange={setSelectedAssignmentId} />
          </div>
        )}
      </div>
      {/* {showGradeInput ? (
        <div className={styles.container}>
          <div className={styles.padding}>
            <div className={classNames(styles.fieldTitle, 'text-label')}>Selection</div>
            <div className={styles.selection}>
              <strong>Aaron Fischer</strong> from <strong>6B Mathematics</strong>
            </div>
          </div>
          <div className={styles.divider}></div>
          <div className={styles.padding}>
            <div className={classNames(styles.fieldTitle, 'text-label')}>Assignment</div>
            <div className={styles.assignment}>Algebra Basics: Laws of Exponents</div>
          </div>
          <div className={styles.gradeInputLayout}>
            <div>
              <div className={classNames(styles.columnTitle, 'text-label')}>Grade</div>
              <div className={styles.columnValue}>
                <GradeInput
                  currentComment="This is some mysterious comment, This is some mysterious comment,This is
                        some mysterious comment,This is some mysterious comment,This is some
                        mysterious comment,"
                  currentGrade="+4"
                  newGrade={value}
                  setNewGrade={setValue}
                />
              </div>
            </div>
            <div>
              <div className={classNames(styles.columnTitle, 'text-label')}>Date</div>
              <div className={styles.columnValue}>
                <div className={styles.date}>
                  <div>
                    <CalendarIcon />
                  </div>
                  <div>11.05.2022</div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.padding}>
            <div className={classNames(styles.fieldTitle, 'text-label')}>Comment</div>
            <div className={styles.commentContainer}>
              <TextField
                multiLine
                placeholder={'Type comment...'}
                className={styles.gradeInput}
                value={value}
                onChange={e => {
                  setValue(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.container}>
          <div className={styles.padding}>
            <div className={classNames(styles.fieldTitle, 'text-label')}>Assignment</div>
            <div className={styles.assignment}>Algebra Basics: Laws of Exponents</div>
          </div>
          <div className={styles.columnLayout}>
            <div>
              <div className={classNames(styles.columnTitle, 'text-label')}>Grade</div>
              <div className={classNames(styles.columnValue, styles.grade)}>+5</div>
            </div>
            <div>
              <div className={classNames(styles.columnTitle, 'text-label')}>Date</div>
              <div className={styles.columnValue}>11.95.2022</div>
            </div>
            <div>
              <div className={classNames(styles.columnTitle, 'text-label')}>Type</div>
              <div className={styles.columnValue}>Homework</div>
            </div>
          </div>
          <div className={styles.padding}>
            <div className={classNames(styles.fieldTitle, 'text-label')}>Comment</div>
            <p className={classNames(styles.commentContent, 'text-paragraph')}>
              There are three types of people in the world. Those who can count and those who can’t.
            </p>
          </div>
        </div>
      )} */}
    </ModalDialog>
  );
};

export default EditGradeModal;
